import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "avatar-wrapper" }
const _hoisted_2 = { class: "nick-name" }

import store from "../store";

import {defineComponent} from "vue";
import Sidebar from "@/components/sidebar/Sidebar.vue";
import { ArrowDown } from "@element-plus/icons-vue";

const __default__ = defineComponent({
  name: "AppLayout",
  components: {
    Sidebar, ArrowDown
  },
  data() {
    return {}
  },
  methods: {
    async logOut() {
      await this.$store.dispatch('user/LogOut');
      await this.$router.push('/auth/login');
      await this.logoutAction();
    },
    /*showDropdown() {
      console.log('show_dropdown');
    },*/
  },
});


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const nickname = store.getters.name;

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_aside, {
        width: "201px",
        span: 3
      }, {
        default: _withCtx(() => [
          _createVNode(Sidebar)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("设置")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, {
                        divided: "",
                        onClick: _ctx.logOut
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("登出")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(nickname)), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowDown))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})